/*=========================================================================================
  File Name: getters.js
  Description: Vuex Store - getters
  ----------------------------------------------------------------------------------------
  Item Name: Vuesax Admin - VueJS Dashboard Admin Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

const getters = {
  // COMPONENT
  // vx-autosuggest
  // starredPages: state => state.navbarSearchAndPinList.data.filter((page) => page.highlightAction),

  accountsGetter: (state) => state.accounts || [],
  mainAccountsGetter: (state) =>
    state.accounts.filter((account) => {
      return account.apiId && account.apiId.indexOf('_t') < 0;
    }),
  testAccountsGetter: (state) =>
    state.accounts.filter((account) => {
      return account.apiId && account.apiId.indexOf('_t') > 0;
    }),
  activeAccountGetter: (state) =>
    state.accounts.find((account) => account.active) || null,
  localCurrencyGetter: (state, getters) =>
    getters.activeAccountGetter
      ? getters.activeAccountGetter.localCurrency
      : '-',
  transactionsGetter: (state, getters) => {
    // Return transactions for the currently active account
    let account = getters.activeAccountGetter;
    if (account && account.transactions) {
      return account.transactions || [];
    }
    // else
    return [];
  },
  cleanedTransactionsGetter: (state, getters) => {
    // Return transactions for the currently active account
    let account = getters.activeAccountGetter;
    if (account && account.cleanedTransactions) {
      return account.cleanedTransactions || [];
    }
    // else
    return [];
  },
  transactionCountsGetter: (state, getters) => {
    // Return transactions for the currently active account
    let account = getters.activeAccountGetter;
    if (account && account.transactionCounts) {
      return account.transactionCounts || [];
    }
    // else
    return [];
  },

  addressesGetter: (state, getters) => {
    //return addresses for the currently active account
    let account = getters.activeAccountGetter;
    if (account && account.addresses) {
      return account.addresses || [];
    }
    return [];
  },

  addressesCountGetter: (state, getters) => {
    // return addresses count for currently active account
    let account = getters.activeAccountGetter;
    if (account && account.addressesCount) {
      return account.addressesCount || [];
    }
    return [];
  },

  payoutNextDateGetter: (state, getters) => {
    let amountDue = getters.payoutBaseAmountDueGetter;
    if (amountDue && amountDue >= 100) {
      // payout at end of day, for the whole amount due up till that point
      return new Date();
    } else {
      // payout on last day of month, no matter the amount
      let tmpdate = new Date();
      return new Date(
        tmpdate.getFullYear(),
        (tmpdate.getMonth() + 1) % 12,
        0,
        23,
        59,
        59
      );
    }
  },
  payoutLocalAmountDueGetter: (state, getters) => {
    let account = getters.activeAccountGetter;
    //console.debug('payoutLocalAmountDueGetter: account is ', JSON.stringify(account, null, 3));
    if (
      account &&
      account.receiveLocalAmount !== undefined &&
      account.payoutLocalAmount !== undefined
    ) {
      return account.receiveLocalAmount - account.payoutLocalAmount;
    }
    return null;
  },
  payoutBaseAmountDueGetter: (state, getters) => {
    let account = getters.activeAccountGetter;
    if (
      account &&
      account.receiveBaseAmount !== undefined &&
      account.payoutBaseAmount !== undefined
    ) {
      return account.receiveBaseAmount - account.payoutBaseAmount;
    }
    return null;
  },
  payoutsGetter: (state, getters) => {
    let account = getters.activeAccountGetter;
    if (account && account.payouts) {
      return account.payouts;
    }
    return [];
  },
  selectedTransactionGetter: (state) => {
    return state.selectedTransaction;
  },
  popupDisplayCounterGetter: (state) => {
    return state.popupDisplayCounter;
  },

  disableRefundsGetter: (state) => {
    return state.disableRefunds;
  },
  selectedAddressGetter: (state) => {
    return state.selectedAddress;
  },
  merchantsGetter: (state) => {
    return state.merchants || [];
  },
  apiCredsGetter: (state) => {
    return state.apiCredentials || [];
  },
  approversGetter: (state) => {
    return state.approvers || [];
  },
  approvalGetter: (state) => {
    return state.approvalTotal || 0;
  },

  activeMerchantGetter: (state, getters) => {
    let activeAccount = getters.activeAccountGetter;
    if (activeAccount) {
      let apiId = activeAccount.apiId;

      let merchantList = getters.merchantsGetter;
      return merchantList.find((merch) => {
        return merch.accounts.find((n) => n.api_id === apiId);
      });
    } else {
      return null;
    }
  },
  activeMerchantKeyGetter: (state, getters) => {
    if (getters.activeMerchantGetter) {
      return getters.activeMerchantGetter.merchant_key;
    } else {
      return null;
    }
  },

  storedActiveMerchantGetter: (state) => {
    return state.activeMerchant;
  },

  searchResultGetter: (state) => {
    return state.searchResult || [];
  },
  payoutListGetter: (state) => {
    // let sorted = state.payoutList.sort(function(a,b){
    //     return new Date(b.status_date) - new Date(a.status_date);
    //   });
    //   return sorted;

    return state.payoutList;
  },
  fiatPayoutListGetter: (state) => {
    return state.fiatPayoutList.data;
  },

  fiatPayoutBalanceListGetter: (state) => {
    return state.fiatPayoutBalances;
  },

  fiatPayoutPaginationGetter: (state) => {
    return state.fiatPayoutList.pagination;
  },

  merchantBankAccountGetter: (state) => {
    return state.merchantBankAccountDetails;
  },

  merchantProfileDetailsGetter: (state) => {
    return state.merchantProfileDetails;
  },
  exchangeRateGetter: (state) => {
    return state.exchangeRate;
  },
  merchantPayoutsGetter: (state) => {
    return state.merchantPayouts;
  },
  activeMerchantBalances: (state, getters) => {
    if (getters.activeAccountGetter) {
      let activeMerchantBalances = getters.activeMerchantGetter.balances;
      return activeMerchantBalances;
    } else {
      return null;
    }
  },
  merchantExchangeRateGetter: (state) => {
    return state.merchantExchangeRate;
  },

  selectedPayoutGetter: (state) => {
    return state.selectedPayout;
  },
  activeUserGetter: (state) => {
    return state.activeUser;
  },
  payoutMetaDataGetter: (state) => {
    return state.payoutMetaData;
  },

  //for dashboard subaccounts and permissions
  currentActiveEntityAdminGetter: (state) => {
    return state.currentActiveEntityAdminData;
  },
  listOfEntityAdminGetter: (state) => {
    return state.entityAdminList;
  },
  permissionGroupsGetter: (state) => {
    return state.permissionGroup;
  },

  permissionGroupsExtraGetter: (state) => (check) => {
    let newGroups = [];
    if (!check) {
      // push only "admin" group
      newGroups.push(state.permissionGroup.find((group) => group.id === 1));
      return newGroups;
    }
    //include 'none' in the permission
    let obj = {};
    obj.id = 0;
    obj.name = 'None';
    newGroups = [...state.permissionGroup];
    newGroups.push(obj);
    return newGroups;
  },

  isAdminGetter: (state) => {
    return state.isAdmin;
  },

  localCurrencyTxnGetter: (state) => {
    //filter the state to only get the local currency transaction (no custody transaction)
    let filteredState =
      state.localCurrencyTxn.data &&
      state.localCurrencyTxn.data.filter(
        (txn) => txn.account_type === 'triplea' && !txn.api_id.includes('_t')
      );
    return filteredState;
  },

  localCurrencyTxnCountsGetter: (state) => {
    return state.localCurrencyTxnCounts;
  },

  refundsGetter: (state) => {
    return state.refundList;
  },

  selectedRefundGetter: (state) => {
    return state.selectedRefund;
  },

  associatedPaymentGetter: (state) => {
    return state.associatedPaymentDetails;
  },

  refundMetaDataGetter: (state) => {
    return state.refundMetaData;
  },

  otpKeyGetter: (state) => {
    return state.otpKey || '';
  },

  otpValueGetter: (state) => {
    return state.otpValue || '';
  },

  depositsGetter: (state) => {
    return state.deposits;
  },
  depositsMetaDataGetter: (state) => {
    return state.depositMetaData;
  },
  entityAdmin2FATypeGetter: (state) => {
    return state.entityAdmin2FAType;
  },
};

export default getters;
